import { Colors } from 'src/components/theme'

type Props = {
  color?: string
}
export const Dash = (props: Props) => {
  const { color } = props

  return (
    <svg width="40" height="2" viewBox="0 0 40 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1H40" stroke={color || Colors.blueDark} strokeOpacity="0.75" strokeWidth="2" strokeDasharray="6 2" />
    </svg>
  )
}
